var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-avatar',_vm._g(_vm._b({staticClass:"mb-1",attrs:{"size":"16","color":_vm.getTaskStatus(_vm.status).color}},'v-avatar',attrs,false),on))]}}])},[_vm._v(" "+_vm._s(_vm.$t(`maintenanceTask.${_vm.getTaskStatus(_vm.status).text}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }